module.exports = __webpack_public_path__ + "static/media/23.2f350857.webp";